import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
const PDPUpholsterySortBy = t0 => {
  const $ = _c(10);
  const {
    isLeather: t1,
    selectedOption,
    setSelectedOption
  } = t0;
  const isLeather = t1 === undefined ? false : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      value: "family",
      label: "Family"
    };
    t3 = {
      value: "popularity",
      label: "Popularity"
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  const t4 = isLeather ? "Grade" : "Tier";
  let t5;
  if ($[2] !== t4) {
    t5 = [t2, t3, {
      value: "tier",
      label: t4
    }];
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const options = t5;
  let t6;
  if ($[4] !== setSelectedOption) {
    t6 = event => {
      setSelectedOption(event?.target?.value);
    };
    $[4] = setSelectedOption;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== options || $[7] !== selectedOption || $[8] !== t6) {
    t7 = <LabeledSelectBox label="Sort by" onChange={t6} options={options} showSingleLineLabelOverlay={true} prefixOptionsWithLabel={true} showBlankOption={false} size="sm" value={selectedOption} />;
    $[6] = options;
    $[7] = selectedOption;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
PDPUpholsterySortBy.propTypes = {
  isLeather: PropTypes.bool,
  selectedOption: PropTypes.string,
  setSelectedOption: PropTypes.func
};
export default PDPUpholsterySortBy;